import type { QueryResult } from '@apollo/client'

import useData from './useData'
import useProjections from './useProjections'
import useSelectedRows from './useSelectedRows'

type TData = any

export default function useDataTable<Data extends TData, T = TData, S extends string = ''>() {
  const { data, queryResult, variables } = useData<T, S>()
  const { projections } = useProjections<T, S>()
  const { selectedRows } = useSelectedRows()

  const value = {
    data,
    queryResult: queryResult as QueryResult<Data>,
    variables,
    projections,
    selectedRows,
  }

  return value
}
